/**
 * @generated SignedSource<<08549ea4de80ed473ebaa8e534a33a28>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationSyncInput = {
  force_sync_merge?: boolean | null | undefined;
  integration_id: number;
};
export type useSyncIntegrationMutation$variables = {
  input: IntegrationSyncInput;
};
export type useSyncIntegrationMutation$data = {
  readonly syncIntegration: {
    readonly integration: {
      readonly id: number;
      readonly last_sync_at: any | null | undefined;
      readonly next_sync_at: any | null | undefined;
      readonly state: string;
    } | null | undefined;
  };
};
export type useSyncIntegrationMutation = {
  response: useSyncIntegrationMutation$data;
  variables: useSyncIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "IntegrationSyncResult",
    "kind": "LinkedField",
    "name": "syncIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "integration",
        "kind": "LinkedField",
        "name": "integration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "last_sync_at",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "next_sync_at",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSyncIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSyncIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3aa4812bbde0f3aaf627247790a29b21",
    "id": null,
    "metadata": {},
    "name": "useSyncIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation useSyncIntegrationMutation(\n  $input: IntegrationSyncInput!\n) {\n  syncIntegration(input: $input) {\n    integration {\n      id\n      state\n      last_sync_at\n      next_sync_at\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2563e095fa78ce9cf597ce109a92c52b";

export default node;
